import { defineMessages } from 'react-intl';
const messages = defineMessages({
    // Panels & headings
    PaymentInformation: { id: 'PaymentInformation', defaultMessage: 'Payment information' },
    TemporaryLicenses: { id: 'TemporaryLicenses', defaultMessage: 'Temporary licenses' },
    AddTemporaryLicense: { id: 'AddTemporaryLicense', defaultMessage: 'Add temporary license' },
    Users: { id: 'Users', defaultMessage: 'Users' },
    // Payment information (left column)
    NextInvoiceDate: { id: 'NextInvoiceDate', defaultMessage: 'Next invoice date' },
    BillingPeriod: { id: 'BillingPeriod', defaultMessage: 'Billing period' },
    CurrentPaymentMethod: { id: 'CurrentPaymentMethod', defaultMessage: 'Current payment method' },
    DirectDebitVia: { id: 'DirectDebitVia', defaultMessage: 'Direct debit via' },
    VisaMasterCardVia: { id: 'VisaMasterCardVia', defaultMessage: 'VISA/MasterCard via' },
    ViaBankTransfer: { id: 'ViaBankTransfer', defaultMessage: 'Via bank transfer' },
    SwitchToBankTransfer: {
        id: 'SwitchToBankTransfer',
        defaultMessage: 'Click here to switch to bank transfer payment',
    },
    BankTransferPayment: { id: 'BankTransferPayment', defaultMessage: 'Bank transfer payment' },
    InTrialUntil: { id: 'InTrialUntil', defaultMessage: 'In trial until' },
    PromoCode: { id: 'PromoCode', defaultMessage: 'Promo code' },
    AccountNumber: { id: 'AccountNumber', defaultMessage: 'Account number' },
    Last4DigitsOfCardNumber: {
        id: 'Last4DigitsOfCardNumber',
        defaultMessage: 'Last 4 digits of card number',
    },
    // License pricing (right column)
    NumberOfLicenses: { id: 'NumberOfLicenses', defaultMessage: 'Number of licenses' },
    NumberOfCustomers: { id: 'NumberOfCustomers', defaultMessage: 'Number of customers' },
    BillingPerRelationBase: {
        id: 'BillingPerRelationBase',
        defaultMessage: 'Base package ({quantity} included)',
    },
    BillingPerRelationExtra: {
        id: 'BillingPerRelationExtra',
        defaultMessage: 'Extra customers ({quantity})',
    },
    BillingPerRelationBucketTitle: {
        id: 'BillingPerRelationBucketTitle',
        defaultMessage: 'Customers',
    },
    BillingPerRelationBucketNrActiveRelations: {
        id: 'BillingPerRelationBucketNrActiveRelations',
        defaultMessage: 'Number of active customers',
    },
    BillingPerRelationBucketBase: {
        id: 'BillingPerRelationBucketBase',
        defaultMessage: 'Base package ({quantity} included)',
    },
    BillingPerRelationBucket: {
        id: 'BillingPerRelationBucket',
        defaultMessage: 'Extra customers',
    },
    BillingPerRelationBucketDiscountInfo: {
        id: 'BillingPerRelationBucketDiscountInfo',
        defaultMessage: 'Yearly discount is included in the shown prices.',
    },
    // Credits
    Credits: { id: 'Credits', defaultMessage: 'Credits' },
    Usage: { id: 'Usage', defaultMessage: 'Usage' },
    FreeCredits: { id: 'FreeCredits', defaultMessage: 'Free credits' },
    MonthlyCredits: { id: 'MonthlyCredits', defaultMessage: 'Monthly credits' },
    YearlyCredits: { id: 'YearlyCredits', defaultMessage: 'Yearly credits' },
    AutomaticallyBuyExtraCredits: {
        id: 'AutomaticallyBuyExtraCredits',
        defaultMessage: 'Automatically buy extra credits',
    },
    AutomaticallyBuyExtraCreditsInfo: {
        id: 'AutomaticallyBuyExtraCreditsInfo',
        defaultMessage: 'When you run out of credits, {credits} extra credits will automatically be bought for {amount}.',
    },
    // Modules
    Amount: { id: 'Amount', defaultMessage: 'Amount' },
    MonthsLower: { id: 'months', defaultMessage: 'months' },
    // Totals & discounts
    YearlyPaymentDiscount: {
        id: 'YearlyPaymentDiscount',
        defaultMessage: 'Yearly payment discount',
    },
    TenantBillingExtraDiscount: {
        id: 'TenantBillingExtraDiscount',
        defaultMessage: 'Extra discount',
    },
    TenantBillingTemporaryDiscount: {
        id: 'TenantBillingTemporaryDiscount',
        defaultMessage: 'Temporary discount (until {until})',
    },
    TotalExclMonth: { id: 'TotalExclMonth', defaultMessage: 'Total excl. / month' },
    TotalExclYear: { id: 'TotalExclYear', defaultMessage: 'Total excl. / year' },
    AgoriaIndexCalculationInfo: {
        id: 'AgoriaIndexCalculationInfo',
        defaultMessage: 'Prices are indexed according to the Agoria index.',
    },
    ConfirmChange: { id: 'Comfirm change', defaultMessage: 'Confirm change' },
    // Temporary licenses table
    BeginDate: { id: 'BeginDate', defaultMessage: 'Begin date' },
    EndDate: { id: 'EndDate', defaultMessage: 'End date' },
    AssignedUser: { id: 'AssignedUser', defaultMessage: 'Assigned user' },
    Unassigned: { id: 'Unassigned', defaultMessage: 'Unassigned' },
    // Add temporary license dialog
    DateFrom: { id: 'DateFrom', defaultMessage: 'From' },
    DateUntil: { id: 'DateUntil', defaultMessage: 'Until' },
    SubtractOneMonth: { id: 'SubtractOneMonth', defaultMessage: '- 1 month' },
    AddOneMonth: { id: 'AddOneMonth', defaultMessage: '+ 1 month' },
    Month: { id: 'Month', defaultMessage: 'Month' },
    Months: { id: 'Months', defaultMessage: 'Months' },
    NrOfMonths: { id: 'NrOfMonths', defaultMessage: 'Nr of months' },
    TotalExcl: { id: 'TotalExcl', defaultMessage: 'Total excl.' },
    DiscountTemporaryLicenses: {
        id: 'DiscountTemporaryLicenses',
        defaultMessage: 'Any yearly discount is not applied to temporary licenses.',
    },
    Add: { id: 'Add', defaultMessage: 'Add' },
    // Tenant credit dialog
    TenantCredits: { id: 'TenantCredits', defaultMessage: 'Credits' },
    StartDate: { id: 'StartDate', defaultMessage: 'Start date' },
    Endate: { id: 'Endate', defaultMessage: 'End date' },
    PaidCredits: { id: 'PaidCredits', defaultMessage: 'Paid credits' },
    UsedCredits: { id: 'UsedCredits', defaultMessage: 'Used credits' },
    AvailableCredits: { id: 'AvailableCredits', defaultMessage: 'Available credits' },
    UsedCreditsPercentage: {
        id: 'UsedCreditsPercentage',
        defaultMessage: 'Used credits (%)',
    },
    Date: { id: 'Date', defaultMessage: 'Date' },
    User: { id: 'User', defaultMessage: 'User' },
    Action: { id: 'Action', defaultMessage: 'Action' },
    Info: { id: 'Info', defaultMessage: 'Info' },
    Close: { id: 'Close', defaultMessage: 'Close' },
    // Set payment provider confirm dialog
    PaymentDetails: { id: 'PaymentDetails', defaultMessage: 'Payment details' },
    ConfirmRegistrationInvoiceInfo: {
        id: 'ConfirmRegistrationInvoiceInfo',
        defaultMessage: 'If you confirm, your registration for AdminPulse will be finalized and an invoice will be created with the following parameters:',
    },
    VatNumber: { id: 'VatNumber', defaultMessage: 'VAT number' },
    KvkNr: { id: 'KvkNr', defaultMessage: 'KvK nr.' },
    Address: { id: 'Address', defaultMessage: 'Address' },
    Discount: { id: 'Discount', defaultMessage: 'Discount' },
    Confirm: { id: 'Confirm', defaultMessage: 'Confirm' },
    Cancel: { id: 'Cancel', defaultMessage: 'Cancel' },
    Update: { id: 'Update', defaultMessage: 'Update' },
    // Toastr / confirmation messages
    msgModuleConfigurationSaved: {
        id: 'msgModuleConfigurationSaved',
        defaultMessage: 'The configuration has been saved.',
    },
    msgNumberLicensesLowerThanEmployees: {
        id: 'msgNumberLicensesLowerThanEmployees',
        defaultMessage: 'The number of licenses cannot be lower than the number of active users.',
    },
    msgPaymentProviderChangedSuccess: {
        id: 'msgPaymentProviderChangedSuccess',
        defaultMessage: 'The payment method has been changed to {provider}.',
    },
    BankTransfer: { id: 'BankTransfer', defaultMessage: 'bank transfer' },
    msgConfirmChangePaymentProvidertitle: {
        id: 'msgConfirmChangePaymentProvidertitle',
        defaultMessage: 'Change payment method?',
    },
    msgConfirmChangePaymentProvider: {
        id: 'msgConfirmChangePaymentProvider',
        defaultMessage: 'Are you sure you want to change the payment method?',
    },
    msgRequiredEnterpriseNumberAndAddress: {
        id: 'msgRequiredEnterpriseNumberAndAddress',
        defaultMessage: 'An enterprise number and a complete address are required.',
    },
});
export default messages;
